/**
 * The type of the action which sets the selected participants-display layout.
 *
 * {
 *     type: SET_PARTICIPANTS_LAYOUT,
 *     layout: string
 * }
 */
export const SET_PARTICIPANTS_LAYOUT = 'SET_PARTICIPANTS_LAYOUT';
